
import { isMobile } from "../utils/common";
import { getProvinces } from "../utils/staticData";
import { mapState } from "vuex";
import { ref } from "vue";
export default {
  props: ["majorName"],
  data() {
    return {
      BASE_URL_STATIC: this.$config.BASE_URL_STATIC,
      pagination: {
        current: 1,
        pageSize: +10,
        total: 23,
      },
      loading: false,
      // baseImageURL: "https://ts-res.tuoitre.vn",
      baseImageURL: this.$config.BASE_URL_RESOURCE,
      mobile: false,
      page: 1,
      page_size: +10,
      columns: [
        {
          title: "Mã",
          dataIndex: "code",
          key: "code",
          width: 80,
          minWidth: 80,
        },
        {
          title: "Tên trường",
          dataIndex: "name",
          key: "name",
          width: 350,
          minWidth: 350,
          customRender: (val, record) => {
            return (
              <div style={{ display: "flex", alignItems: "center" }}>
                <img
                  style={{ width: "39px", height: "39px" }}
                  class="all-school-icon-school"
                  src={`${this.baseImageURL}${record.logo}`}
                  alt=""
                  onError={this.handleError}
                />
                <div> {val} </div>
              </div>
            );
          },
        },
        {
          title: () => {
            return (
              <div>
                {" "}
                {!this.majorName ? "Học phí(tr/năm)" : "Học phí(tr/năm)"}
              </div>
            );
          },
          width: 150,
          minWidth: 150,
          dataIndex: "total_majors",
          key: "total_majors",
          customRender: (val, record) => {
            return <div>{`${record.tuition_min} - ${record.tuition_max}`}</div>;
          },
        },
        {
          width: 200,
          minWidth: 200,
          title: "Địa điểm",
          dataIndex: "address_default_province",
          key: "address_default_province",
          customRender: (val, record) => {
            return <div>{val}</div>;
          },
        },
        {
          title: () => {
            return (
              <div> {!this.majorName ? "Chỉ tiêu" : "Chỉ tiêu tuyển sinh"}</div>
            );
          },
          width: 150,
          minWidth: 150,
          dataIndex: "targets",
          key: "targets",
          customRender: (val, record) => {
            // return <div>{!this.majorName ? val : record.targets}</div>;
            return (
              <div>
                {!this.majorName
                  ? this.convertNumber(val)
                  : this.convertNumber(record.targets)}
              </div>
            );
          },
        },
      ],
      columnMoblie: [
        {
          title: "Tên trường",
          dataIndex: "name",
          key: "name",
          customRender: (val, record) => {
            return (
              <div style={{ display: "flex", alignItems: "flex-start" }}>
                <img
                  style={{ width: "39px", height: "39px" }}
                  class="all-school-icon-school"
                  src={`${this.baseImageURL}/${record.logo}`}
                  alt=""
                />
                <div>
                  <div> {val} </div>
                  <div
                    style={{ color: "rgba(56, 54, 50, 0.7)", fontWeight: 300 }}
                  >
                    {" "}
                    {record.code}{" "}
                  </div>
                </div>
              </div>
            );
          },
        },
        {
          // title: `Tiêu chuẩn tuyển sinh`,
          title: "Tiêu chuẩn",
          dataIndex: "targets",
          key: "targets",
          customRender: (val, record) => {
            return (
              <div style={{ display: "flex", justifyContent: "end" }}>
                {val}
              </div>
            );
          },
        },
      ],
      value1: ref("Địa điểm"),
      value2: ref("Học phí"),
      valueSearch: "",
      timer: undefined,
      params: {
        page: 1,
        page_size: +10,
        valueSearch: "",
        provinceId: "",
        dataTuition: "",
        showMore: false,
        resetSearch: false,
        resetFilter: false,
        resetTuition: false,
      },
      provinces: [],
      arrTuition: [
        {
          name: "Tất cả",
          code: "",
        },
        {
          name: "Dưới 15tr/năm",
          code: "<15",
        },
        {
          name: "15-30tr/năm",
          code: "15-30",
        },
        {
          name: "31-50tr/năm",
          code: "31-50",
        },
        {
          name: "Trên 50tr/năm",
          code: ">50",
        },
      ],
      windowWidth: 0,
    };
  },

  async mounted() {
    this.windowWidth = window.innerWidth;
    this.mobile = isMobile();

    this.mapProvinces();
    const range = this.$route.query.range;
    if (range) {
      this.value2 = range;
      this.params.dataTuition = range;
      await this.getSchoolList("filterTuition");
    } else {
      await this.getSchoolList("default");
    }
  },
  methods: {
    displayHPDD() {
      if (this.mobile == true) {
        if (this.value1 === "Địa điểm" && this.value2 === "Học phí") {
          return false;
        }
        return true;
      }
      return false;
    },
    convertNumber(num) {
      const convertNum = +num;
      return convertNum.toLocaleString();
    },
    async handleTableChange(pagination) {
      this.params.showMore = true;
      this.params.page = pagination.current;
      if (this.params.valueSearch !== "") {
        await this.getSchoolList("search");
      } else if (
        this.params.provinceId !== "" &&
        this.params.provinceId !== 1000
      ) {
        await this.getSchoolList("filter");
      } else if (this.params.dataTuition !== "") {
        await this.getSchoolList("filterTuition");
      } else {
        await this.getSchoolList("default");
      }
      // alert(pagination.current)
    },
    handleError(event) {
      event.target.src = `${this.BASE_URL_STATIC}/storages/2025-08-14/6f6470b16947404685687028e97c2aef.png`;
    },
    customRow(record, index) {
      return {
        on: {
          click: () => {
            this.$router.push(`/school/${record.id || 20}`);
          },
        },
      };
    },
    getUser() {
      return this.majorName;
    },
    checkMajor() {
      if (this.majorName != "undefined" && this.majorName != "") {
        return false;
      }
      return true;
    },
    mapProvinces() {
      let proVinceDefault = {
        name: "Toàn quốc",
        code: "1000",
      };
      this.provinces = [proVinceDefault, ...getProvinces("array")];
    },
    async getSchoolList(type) {
      console.log({ type });
      if (
        (this.params.provinceId == 1000 &&
          this.valueSearch == "" &&
          this.params.dataTuition === "") ||
        (this.params.provinceId == "Địa điểm" &&
          this.valueSearch == "" &&
          this.params.dataTuition === "")
      ) {
        type = "default";
      }
      this.loading = true;
      await this.$store
        .dispatch("ListSchool/getListSchool", {
          params: this.params,
          type,
          majorName: this.majorName,
        })
        .then(() => {
          this.pagination.current = +this.current_page;
          // this.pagination.pageSize = +this.current_page
          this.pagination.pageSize = +10;
          this.pagination.total = +this.total_item_school;
          setTimeout(() => {
            this.loading = false;
          }, 500);
        });
      setTimeout(() => {
        this.loading = false;
      }, 1000);
    },
    async textSearch(e) {
      clearTimeout(this.timer);
      this.params.page = 1;
      this.params.valueSearch = event.target.value;
      this.params.showMore = false;
      this.params.resetSearch = true;
      this.value1 = ref("Địa điểm");
      this.value2 = ref("Học phí");
      this.timer = setTimeout(async () => {
        await this.getSchoolList("search");
      }, 1500);
    },
    async showMoreFunc() {
      this.params.showMore = true;
      if (this.params.valueSearch !== "") {
        await this.getSchoolList("search");
      } else if (this.params.provinceId !== "") {
        await this.getSchoolList("filter");
      } else {
        await this.getSchoolList("default");
      }
    },
    async handleFilterChange(value) {
      this.params.page = 1;
      this.valueSearch = "";
      this.value2 = ref("Học phí");
      this.params.showMore = false;
      this.params.provinceId = value;
      this.params.resetFilter = true;
      if (value == 1000 || value == "Địa điểm") {
        await this.getSchoolList("default");
      } else {
        await this.getSchoolList("filter");
      }
    },
    async handleFilterChangeTuition(value) {
      this.params.page = 1;
      this.valueSearch = "";
      this.params.showMore = false;
      this.params.provinceId = 1000;
      this.params.resetTuition = true;
      this.params.dataTuition = value;
      this.value1 = ref("Địa điểm");
      if (value == 1000 || value == "Địa điểm") {
        await this.getSchoolList("default");
      } else {
        await this.getSchoolList("filterTuition");
      }
    },
    async onEnter() {
      this.params.valueSearch = event.target.value;
      this.params.showMore = false;
      this.params.resetSearch = true;
      await this.getSchoolList("search");
      this.value1 = ref("Địa điểm");
      clearTimeout(this.timer);
    },
  },
  computed: {
    ...mapState("ListSchool", [
      "list_school",
      "total_item_school",
      "current_page",
      "introduction",
    ]),
    MY_CONSTANT: function () {
      return 10;
    },
  },
};
